// Auto-generated product-to-image mapping - DO NOT EDIT MANUALLY
// Generated: 2025-10-13T11:09:39.058Z
// Total mappings: 235

import type { ProductImageMapping } from '../types/image';

export const productImageMapping: ProductImageMapping = new Map<string, string>([
  ['24801', 'IMG_001'],
  ['73012', 'IMG_002'],
  ['73013', 'IMG_002'],
  ['73014', 'IMG_002'],
  ['73015', 'IMG_002'],
  ['73022', 'IMG_002'],
  ['73023', 'IMG_003'],
  ['73024', 'IMG_003'],
  ['73025', 'IMG_003'],
  ['75000', 'IMG_004'],
  ['75032', 'IMG_005'],
  ['75033', 'IMG_005'],
  ['75034', 'IMG_005'],
  ['75035', 'IMG_006'],
  ['242408', 'IMG_007'],
  ['333915', 'IMG_008'],
  ['385815', 'IMG_008'],
  ['385820', 'IMG_008'],
  ['404615', 'IMG_008'],
  ['404620', 'IMG_008'],
  ['SP-FT#25', 'IMG_009'],
  ['SP-FT#3', 'IMG_010'],
  ['SP-FT#5', 'IMG_010'],
  ['SP-661W', 'IMG_010'],
  ['SP-961W', 'IMG_011'],
  ['SP-881W', 'IMG_012'],
  ['SP-883W', 'IMG_012'],
  ['SP-991W', 'IMG_013'],
  ['SP-993W', 'IMG_013'],
  ['CHPM661 B', 'IMG_014'],
  ['CHPM961 B', 'IMG_015'],
  ['SP-KBX11', 'IMG_016'],
  ['SP-KBX88', 'IMG_016'],
  ['SP-KBX22', 'IMG_016'],
  ['SP-KBX33', 'IMG_016'],
  ['SP-KBX44', 'IMG_017'],
  ['SP-FT#2', 'IMG_009'],
  ['CHPM881 B', 'IMG_018'],
  ['SP-FD6P', 'IMG_017'],
  ['SP- FT#HDG', 'IMG_009'],
  ['SP-FT#15', 'IMG_009'],
  ['SP-FT#1', 'IMG_009'],
  ['CHPM883 B', 'IMG_019'],
  ['CHPM991 B', 'IMG_019'],
  ['CHPM993 B', 'IMG_019'],
  ['PHPM71W', 'IMG_020'],
  ['PHPM91W', 'IMG_020'],
  ['PHPM93W', 'IMG_021'],
  ['BC16', 'IMG_022'],
  ['BC24', 'IMG_022'],
  ['BC32', 'IMG_023'],
  ['BC36', 'IMG_024'],
  ['BC48', 'IMG_024'],
  ['BR12', 'IMG_025'],
  ['BR16', 'IMG_025'],
  ['BR24', 'IMG_025'],
  ['BR28', 'IMG_025'],
  ['BR32', 'IMG_026'],
  ['BR38', 'IMG_026'],
  ['BR58', 'IMG_026'],
  ['BR32C2', 'IMG_026'],
  ['BR36C3', 'IMG_027'],
  ['BSQ40', 'IMG_028'],
  ['BQ4830', 'IMG_029'],
  ['SP -S- 1101', 'IMG_030'],
  ['W-81', 'IMG_031'],
  ['W-91', 'IMG_032'],
  ['TH-6X6', 'IMG_033'],
  ['TH-9X6', 'IMG_034'],
  ['ML-BW81', 'IMG_035'],
  ['ML-BW83', 'IMG_036'],
  ['ML-BW91', 'IMG_037'],
  ['ML- BW93', 'IMG_038'],
  ['SP-PS-05', 'IMG_039'],
  ['SP -S- 1102', 'IMG_040'],
  ['SP -S- 1103', 'IMG_041'],
  ['SP -S-1105', 'IMG_042'],
  ['SP -S-1107', 'IMG_043'],
  ['SP-PS-06', 'IMG_039'],
  ['SP-PS- 955', 'IMG_044'],
  ['SP-PS- 088', 'IMG_045'],
  ['SP-PS- 083C', 'IMG_046'],
  ['SP-PS- 099', 'IMG_047'],
  ['SP-PS- 093X', 'IMG_048'],
  ['V-83C', 'IMG_049'],
  ['V-91C', 'IMG_049'],
  ['V-93C', 'IMG_049'],
  ['08EVIDEN', 'IMG_050'],
  ['16EVIDEN', 'IMG_050'],
  ['20EVIDENT', 'IMG_050'],
  ['24EVIDENT', 'IMG_050'],
  ['32EVIDEN', 'IMG_050'],
  ['35EVIDENT', 'IMG_051'],
  ['V-61C', 'IMG_052'],
  ['V-96C', 'IMG_053'],
  ['V-81C', 'IMG_049'],
  ['DH-08', 'IMG_051'],
  ['DH-12', 'IMG_051'],
  ['DH-16', 'IMG_051'],
  ['DH-32', 'IMG_054'],
  ['DH-LID', 'IMG_054'],
  ['DCHPP850', 'IMG_054'],
  ['DCHPP1250', 'IMG_054'],
  ['SP-PC6oz- 96', 'IMG_055'],
  ['SP-PC896', 'IMG_055'],
  ['SP-PC1296', 'IMG_056'],
  ['SP- PC16112', 'IMG_056'],
  ['SP-PPL96', 'IMG_056'],
  ['SP-PPL520', 'IMG_057'],
  ['C-KDL116- PET', 'IMG_058'],
  ['SHP14510 0', 'IMG_059'],
  ['LHFC145 125', 'IMG_060'],
  ['SHP15621 00', 'IMG_061'],
  ['DCHPP1650', 'IMG_054'],
  ['DCHPP32 50', 'IMG_054'],
  ['DLHPP50', 'IMG_062'],
  ['KR150F', 'IMG_063'],
  ['KR1524', 'IMG_062'],
  ['KR1532', 'IMG_062'],
  ['SP- KFB1516 /KR1516', 'IMG_062'],
  ['SHP26210 0', 'IMG_064'],
  ['LHFC622 25', 'IMG_065'],
  ['SHP32574 100', 'IMG_066'],
  ['SHP47410 0', 'IMG_067'],
  ['SHP55741 25', 'IMG_068'],
  ['LHFC743 25455', 'IMG_069'],
  ['SHP26212 5B', 'IMG_070'],
  ['SHP47412 5B', 'IMG_070'],
  ['CP010', 'IMG_071'],
  ['CP021', 'IMG_072'],
  ['CPL022', 'IMG_073'],
  ['CHC0592', 'IMG_074'],
  ['CHC0878 50', 'IMG_074'],
  ['CHC099250L', 'IMG_074'],
  ['CHC107850', 'IMG_074'],
  ['CHC129250', 'IMG_074'],
  ['CHC149850', 'IMG_074'],
  ['CHC169850', 'IMG_075'],
  ['42CKFSK PSM.WH', 'IMG_076'],
  ['KIT-SFK- 2POL-001', 'IMG_077'],
  ['31MPH800', 'IMG_078'],
  ['41MPH600', 'IMG_079'],
  ['FHPHW10 00', 'IMG_080'],
  ['SHPHW10 00', 'IMG_081'],
  ['KHPHW1 000', 'IMG_082'],
  ['1HWHF1000B', 'IMG_083'],
  ['1HWHS1000B', 'IMG_084'],
  ['1HWHK1000B', 'IMG_085'],
  ['LHSDC98 100HO', 'IMG_086'],
  ['LHDC981 00WH', 'IMG_087'],
  ['LHFC107 50HX', 'IMG_087'],
  ['CHC209850', 'IMG_075'],
  ['CHC249850', 'IMG_075'],
  ['CHC3210725-', 'IMG_075'],
  ['310498IN', 'IMG_075'],
  ['LHFC921 00HX', 'IMG_088'],
  ['LHFC921 00WH', 'IMG_088'],
  ['LHDC921 00HO', 'IMG_089'],
  ['LHDC921 00WH', 'IMG_090'],
  ['LHFC981 00HX', 'IMG_091'],
  ['LHFC981 00WH', 'IMG_091'],
  ['C-KC626TS- SH', 'IMG_092'],
  ['31HWPH50B', 'IMG_093'],
  ['41HWPH400', 'IMG_093'],
  ['LHDC981 00HO', 'IMG_094'],
  ['WIDN6M', 'IMG_093'],
  ['KDN6M', 'IMG_095'],
  ['DN3000-DN201502 V', 'IMG_096'],
  ['21/4x50', 'IMG_097'],
  ['3x165-1PLY', 'IMG_098'],
  ['3x95-2PLY', 'IMG_099'],
  ['BNB1M', 'IMG_100'],
  ['BEVNAP1 M-W', 'IMG_101'],
  ['Thermal - RR8313', 'IMG_102'],
  ['SP-20090', 'IMG_006'],
  ['SP-20091', 'IMG_006'],
  ['SP-20092', 'IMG_006'],
  ['SP WS7 - EMP-011', 'IMG_103'],
  ['EMP-011- BLK', 'IMG_104'],
  ['EMP-030', 'IMG_104'],
  ['EMP-016', 'IMG_105'],
  ['EMP-020', 'IMG_106'],
  ['SP-BOBA', 'IMG_107'],
  ['Biost-0003', 'IMG_108'],
  ['SP SC5- EMP0002', 'IMG_109'],
  ['THANK -SMILET- SAK', 'IMG_110'],
  ['THW1A', 'IMG_110'],
  ['#2 Bag', 'IMG_111'],
  ['#4 Bag', 'IMG_111'],
  ['FP-GT1036', 'IMG_003'],
  ['FP-GT1037', 'IMG_003'],
  ['FP-GT1038', 'IMG_003'],
  ['FP-GT1039', 'IMG_005'],
  ['25lb Bag', 'IMG_112'],
  ['#1/6 BBLBag', 'IMG_112'],
  ['#1/8 PPGBag', 'IMG_112'],
  ['#20lb Bag', 'IMG_112'],
  ['PB10513Kraft', 'IMG_113'],
  ['PB10714Kraft', 'IMG_113'],
  ['PB13671358 Kraft', 'IMG_113'],
  ['PB12717Kraft', 'IMG_113'],
  ['PB12915Kraft', 'IMG_113'],
  ['PB141015Kraft', 'IMG_113'],
  ['SP- CFOLD', 'IMG_114'],
  ['M- WHITE2', 'IMG_115'],
  ['P-RT800', 'IMG_116'],
  ['#6 Bag', 'IMG_111'],
  ['#8 Bag', 'IMG_111'],
  ['#12 Bag', 'IMG_112'],
  ['24330W', 'IMG_007'],
  ['P4015XC', 'IMG_117'],
  ['4HPC', 'IMG_118'],
  ['8HPC', 'IMG_118'],
  ['10HPC', 'IMG_118'],
  ['12HPC', 'IMG_118'],
  ['16HPC', 'IMG_118'],
  ['SP- LC08WH', 'IMG_118'],
  ['SP- LC08BK', 'IMG_119'],
  ['SP-LC1216WSHP-', 'IMG_120'],
  ['LC1216B K', 'IMG_120'],
  ['SP-PAP76', 'IMG_121'],
  ['43483W', 'IMG_117'],
  ['MR38603 MC', 'IMG_117'],
  ['MT601XW', 'IMG_008'],
  ['RX4433X G', 'IMG_008'],
  ['SP- FO6x55', 'IMG_122'],
  ['SP-FO6x9X', 'IMG_122'],
  ['SP- FO8x80', 'IMG_123'],
  ['SP-FO8x8', 'IMG_124'],
  ['FIORI- 00244', 'IMG_125'],
  ['FIORI- 00273', 'IMG_126'],
  ['FIOR - 00243', 'IMG_127'],
  ['FIOR- 00232', 'IMG_127'],
  ['W-PALL', 'IMG_128'],
  ['SP-FO9x9', 'IMG_124']
]);
